package top.wcpe.allincore.ui.runtime.ir.api

import kotlin.jvm.JvmField

/** DSL 内建对象 `persist` 暴露的方法集（仅命令式方法走此通道）。 */
interface PersistApi {
    /** 把当前内存中所有 persist 字段一次性写入磁盘。 */
    fun save()

    /** 重新读取磁盘中的 persist 文件，覆盖内存中所有 persist 字段值。 */
    fun reload()

    companion object {
        /** 默认实现：save / reload 不做任何动作。 */
        @JvmField
        val NOOP: PersistApi = object : PersistApi {
            override fun save() {}
            override fun reload() {}
        }
    }
}
